import { render, staticRenderFns } from "./VueBridgeApp.vue?vue&type=template&id=0152dfc8&"
import script from "./VueBridgeApp.vue?vue&type=script&lang=js&"
export * from "./VueBridgeApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports